import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

const NextTrip = () => {
  return (
    <section className="w-full bg-white font-poppins py-5 md:py-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">

        {/* Top Header Section */}
        <div className="flex flex-col md:flex-row justify-start items-start gap-5 md:gap-10 mb-5 ">
          {/* Top Left Label */}
          <div className="flex items-center gap-4 mb-5 md:mb-0 mt-5 md:mt-10">
            <span className="text-[12px] md:text-[14px] font-bold text-[#00261E] tracking-[0.05em]">
              Stress-free airport parking starts here
            </span>
            <div className="flex items-center">
              <div className="h-[0.5px] w-16 md:w-24 bg-[#00261E]/40"></div>
              <div className="w-[6px] h-[6px] border-t-[1px] border-r-[1px] border-[#00261E]/40 rotate-45 -ml-[3px]"></div>
            </div>
          </div>

          {/* Large Heading Section */}
          <div className="text-[#00261E] w-full md:w-auto flex flex-col md:items-end">
            <h2 className="flex flex-col text-[32px] sm:text-[38px] md:text-[42px] lg:text-[45px] font-black uppercase leading-[1.3] tracking-tighter">
              <span className="whitespace-nowrap">Compare & Book</span>
              <span className="md:ml-20 whitespace-nowrap">Airport Parking <span className="text-lightprimary">Deals</span></span>
              <span className="text-lightprimary md:ml-[160px] whitespace-nowrap">Save Up To</span>
              <span className="text-lightprimary md:ml-[240px] whitespace-nowrap">70% Today.</span>
            </h2>
          </div>
        </div>

        {/* Middle/Bottom Content Section */}
        <div className="flex flex-col md:flex-row items-center gap-5 md:gap-10">

          {/* Image Section (flex-1, justify-end) */}
          <div className="flex-1 flex justify-end relative animate-fade-in">
            <img
              src={require("../../../common/images/adventure-section-1.png")}
              alt="Luxury Adventure"
              className="w-full max-w-[500px] h-auto object-contain transform hover:scale-[1.02] transition-transform duration-700"
            />
          </div>

          {/* Text Section (flex-1, justify-start) */}
          <div className="flex-1 flex justify-start">
            <div className="flex flex-col items-start gap-5 md:gap-8 max-w-sm">
              <p className="text-[14px] md:text-[16px] text-gray-800 font-medium leading-relaxed">
                Flying from a UK airport? Don't overpay for parking. At AirportParkingDeals.co.uk, we compare official on-site parking, meet & greet, and park & ride options — so you always get the best price before you travel.
              </p>

              <div className="flex items-center gap-5 group cursor-pointer">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#00261E] rounded-full flex items-center justify-center transition-transform duration-500 group-hover:rotate-45 shadow-xl">
                  <FiArrowUpRight className="text-white text-2xl md:text-3xl" />
                </div>
                <div className="flex flex-col">
                  <span className="text-[12px] md:text-[14px] font-black uppercase tracking-[0.1em] text-[#00261E] leading-tight">
                    Book smarter, travel<br />further for less
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default NextTrip;
